(function () {
  'use strict';

  function injectBannerStyles() {
    if (document.getElementById('sp-consent-style')) return;
    var style = document.createElement('style');
    style.id = 'sp-consent-style';
    style.textContent =
      '#shopify-pc__banner__btn-accept{' +
        'background:#3C5A96!important;' +
        'border-color:#3C5A96!important;' +
        'color:#fff!important;' +
      '}' +
      '#shopify-pc__banner__btn-accept:hover{' +
        'background:#273A61!important;' +
        'border-color:#273A61!important;' +
      '}';
    document.head.appendChild(style);
  }

  function loadApprovedScripts() {
    if (!window.Shopify || !Shopify.customerPrivacy) return;
    if (!Shopify.customerPrivacy.marketingAllowed()) return;

    document.querySelectorAll('[data-consent-script="marketing"][data-src]').forEach(function (node) {
      if (node.dataset.loaded === 'true') return;
      node.dataset.loaded = 'true';
      var script = document.createElement('script');
      script.src = node.dataset.src;
      script.async = true;
      document.head.appendChild(script);
    });
  }

  function initialize() {
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
    Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) {
          loadApprovedScripts();
        }
      }
    );
  }

  injectBannerStyles();
  document.addEventListener('visitorConsentCollected', loadApprovedScripts);
  initialize();
})();
